/**
 * Polled fragments ([up-poll]) reload with no fail target: Unpoly's poller
 * passes nothing for failed responses, so a non-2xx answer has nowhere to
 * render and is thrown as up.CannotMatch ("No target selector given for
 * failed responses") — straight into window.onerror and Datadog RUM, once
 * per interval, in every open tab, for as long as the server answers 5xx
 * (a deploy's revision swap, for instance).
 *
 * up:fragment:poll is the render's guard event and carries its renderOptions,
 * so this is where a failed poll becomes what it should be: a no-op that
 * keeps the fragment's last state and retries next interval. A render that
 * fails with a :none target rejects with an up.RenderResult, which
 * up.error.throwCritical does not rethrow.
 */
export const silenceFailedPoll = (event) => {
  event.renderOptions.failTarget = ":none"
}

const start = ({ up }) => {
  up.on("up:fragment:poll", silenceFailedPoll)
}

export default { start, silenceFailedPoll }
